module.exports = __webpack_public_path__ + "exclamation-085f83db74163f86c1ec995aec9517f8.png";